import { Button, Icons, Modal, Typography, useModal } from '@pankod/refine-antd'
import { useNotification, useTranslate } from '@pankod/refine-core'
import { API_URL } from 'utility'
import { currentSession } from 'utility/authLocal'

type MagicLinkButtonProps = {
  email: string
}

export const MagicLinkButton: React.FC<MagicLinkButtonProps> = ({ email }) => {
  const { modalProps, show, close } = useModal()
  const { open } = useNotification()
  const t = useTranslate()

  const sendMagicLink = async () => {
    try {
      const res = await fetch(`${API_URL}/admin/magic-link`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${currentSession()?.access_token}`
        },
        body: JSON.stringify({ email })
      })

      if (!res.ok) {
        const text = await res.text()
        throw new Error(text)
      }

      open?.({
        type: 'success',
        message: t('magicLink.successMessage', { email }),
        description: t('magicLink.successDescription')
      })
      close()
    } catch (error) {
      open?.({ type: 'error', description: t('magicLink.errorSend'), message: '' })
      console.error(error)
    }
  }
  return (
    <>
    <Button onClick={() => show()} danger size="small">
      <Icons.RocketOutlined style={{ color: '#fb7e54' }} />
    </Button>

    <Modal
      {...modalProps}
      title={t('magicLink.title')}
      centered
      onOk={() => sendMagicLink()}
      okText={t('magicLink.send')}
      onCancel={close}
      style={{ minWidth: '40svw' }}
    >
      <Typography>{t('magicLink.advise', { email: email })}</Typography>
    </Modal>
    </>
  )
}
